import React from 'react'
import { ManagerDTO } from '../../interface/ManagerType'
import { DataRow } from 'medere-ui-framework'
import { useIntl } from 'react-intl';

export default function ManagerCard({entity,rowOptionsMenuOverlay}:{entity:ManagerDTO, rowOptionsMenuOverlay?: (e:ManagerDTO)=>React.ReactNode}) {
  const intl = useIntl();

  return <div className='flex flex-column entityCardContainer mx-1'>
    {rowOptionsMenuOverlay?.(entity)}  
    <p className='font-bold text-xl line-height-auto'>{entity.commercialname}</p>
    <DataRow className='mt-2 w-8 sm:w-4' keyValue={intl.formatMessage({id: "BusinessName"})} value={entity.businessname} divider />
    <DataRow className='w-8 sm:w-4' keyValue={intl.formatMessage({id: "Document"})} value={entity.document} divider  />
    <DataRow className='w-8 sm:w-4' keyValue={intl.formatMessage({id: "Active"})} value={<i className={entity.entitystate == 1? "pi pi-check":"pi pi-times"} />}  />
    
  </div>  

}
